/**
 * 블로그 목록 쿼리 키·페이지 크기와 서버 프리페치.
 * 서버 프리페치(page.tsx)와 클라이언트 훅(article.query.ts)이 같은 키를 써야
 * 하이드레이션이 맞물린다. 어긋나면 곧바로 다시 요청해 서버가 실은 목록이 버려진다.
 *
 * 목록을 서버에서 받아 두지 않으면 크롤러가 받는 HTML에 글 카드·상세 링크가 없다.
 * 구글은 렌더링으로 복구하지만 네이버는 JS 렌더링이 제한적이다.
 */
import {
  getBlogArticleList,
  getBlogTopArticleList,
} from '@/services/article.service';
import { QUERY_KEYS } from '@/services/base-api';
import { GetArticleListParams } from '@/services/types/article.type';
import { QueryClient } from '@tanstack/react-query';

/** 블로그 목록 한 페이지 글 수 */
export const BLOG_LIST_LIMIT = 7;

export function blogArticleListQueryKey(params?: GetArticleListParams) {
  return [QUERY_KEYS.ARTICLE, QUERY_KEYS.LIST, 'blog', params] as const;
}

export function blogTopArticleListQueryKey() {
  return [QUERY_KEYS.ARTICLE, QUERY_KEYS.LIST, 'blog'] as const;
}

/** URL의 page 쿼리를 목록 페이지 번호로. 클라이언트 BlogListContainer와 같은 규칙이다. */
export function parseListPage(page: string | string[] | undefined) {
  return parseInt((Array.isArray(page) ? page[0] : page) || '1', 10);
}

/** 블로그 목록을 서버 쿼리 캐시에 넣는다. 실패하면 비워 두고 클라이언트가 다시 받는다. */
export function prefetchBlogArticleList(
  queryClient: QueryClient,
  params: GetArticleListParams,
) {
  return queryClient.prefetchQuery({
    queryKey: blogArticleListQueryKey(params),
    queryFn: () => getBlogArticleList(params),
  });
}

export function prefetchBlogTopArticleList(queryClient: QueryClient) {
  return queryClient.prefetchQuery({
    queryKey: blogTopArticleListQueryKey(),
    queryFn: getBlogTopArticleList,
  });
}
